import { Globals } from './../../../globals';
import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { NavController, NavParams, ToastController } from 'ionic-angular';

@Component({
  selector: 'page-configuration-social',
  templateUrl: 'configuration-social.html',
})
export class ConfigurationSocialPage {
  public form: FormGroup;

  socialIcons = [
    { key: 'facebook', name: 'Facebook', icon: 'assets/icons/social/facebook.png' },
    { key: 'twitter', name: 'Twitter/X', icon: 'assets/icons/social/twitter.png' },
    { key: 'instagram', name: 'Instagram', icon: 'assets/icons/social/instagram.png' },
    { key: 'linkedin', name: 'LinkedIn', icon: 'assets/icons/social/linkedin.png' },
    { key: 'youtube', name: 'YouTube', icon: 'assets/icons/social/youtube.png' },
    { key: 'whatsapp', name: 'WhatsApp', icon: 'assets/icons/social/whatsapp.png' },
    { key: 'tiktok', name: 'TikTok', icon: 'assets/icons/social/tiktok.png' },
    { key: 'web', name: 'Web', icon: 'assets/icons/social/internet.png' },
  ];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public globals: Globals,
    private afs: AngularFirestore,
    private toastCtrl: ToastController,
    private translate: TranslateService) { }

  ngOnInit() {
    this.form = this.fb.group({
      socialLinks: this.fb.array([])
    });

    this.loadSocialLinks();
  }

  loadSocialLinks() {
    const restaurantUid = this.globals.restaurant_uid;
    if (!restaurantUid) {
      return;
    }

    this.afs.collection('restaurants').doc(restaurantUid).valueChanges().subscribe((restaurant: any) => {
      if (!restaurant) {
        return;
      }

      const socialLinks = restaurant.social_links || [];

      this.globals.restaurant = {
        ...this.globals.restaurant,
        social_links: socialLinks
      };

      while (this.socialLinks.length !== 0) {
        this.socialLinks.removeAt(0);
      }

      if (socialLinks.length > 0) {
        socialLinks.forEach((link: any) => {
          this.socialLinks.push(
            this.fb.group({
              selectedSocial: [link.selectedSocial, Validators.required],
              socialLink: [link.socialLink, Validators.required]
            })
          );
        });
      } else {
        this.addSocialLink();
      }

      this.form.updateValueAndValidity();
    }, (error) => {});
  }

  updateSelectedIcon(index: number, event: any) {
    const selectedKey = event.target.value;
    this.socialLinks.at(index).patchValue({ selectedSocial: selectedKey });
  }

  addSocialLink() {
    this.socialLinks.push(
      this.fb.group({
        selectedSocial: ['instagram', Validators.required], // Default to Instagram
        socialLink: ['', [Validators.required]] // Add URL Validator
      })
    );
  }

  getSocialIcon(key: string) {
    return this.socialIcons.find(social => social.key === key);
  }

  get socialLinks(): FormArray {
    return this.form.get('socialLinks') as FormArray;
  }

  removeSocialLink(index: number) {
    this.socialLinks.removeAt(index);
  }

  getRemainingSocialIcons() {
    const selectedKeys = this.socialLinks.value.map(social => social.selectedSocial);
    return this.socialIcons.filter(social => !selectedKeys.includes(social.key));
  }

  submit() {
    if (this.form.valid) {
      const socialLinks = this.form.value.socialLinks;
      const restaurantUid = this.globals.restaurant_uid;

      if (!restaurantUid) {
        return;
      }

      // Validate URLs before saving
      for (const link of socialLinks) {
        if (!link.socialLink) {
          this.translate.get("toast.invalid_url").subscribe((res: string) => {
            this.showToast(res);
          });
          return;
        }
      }

      // Save to Firestore
      this.afs.collection('restaurants').doc(restaurantUid).update({ social_links: socialLinks })
        .then(() => {
          this.translate.get("toast.success_update").subscribe((res: string) => {
            this.showToast(res);
          });

          this.globals.restaurant = {
            ...this.globals.restaurant,
            social_links: socialLinks
          };
        })
        .catch(error => {
          this.translate.get("toast.error_update").subscribe((res: string) => {
            this.showToast(res);
          });
        });
    }
  }

  showToast(message: string) {
    const toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-social/configuration-social.ts